import axios from 'axios';

import Api from './Api';

class SessaoApi extends Api {
    async apregoar(numeroProcesso, idSessao) {
        const url = `${this.configuracao.urlPregoes + this.localizacao}/sessoes/${idSessao}/processos/${numeroProcesso}`;
        return this.fetch(url, 'POST');
    }

    async apregoarPlanilha(idSessao, relator, marcarAusenciasAdvogados = false, totalDeProcessos) {
        const url = `${
            this.configuracao.urlPregoes + this.localizacao
        }/sessoes/${idSessao}/relator/${relator.sigla}-${relator.cpf}/planilha?marcarAusenciasAdvogados=${marcarAusenciasAdvogados}${totalDeProcessos ? '&totalDeProcessos=' + totalDeProcessos : ''}`;
        return this.fetch(url, 'POST');
    }

    async cancelarPregaoLote(idSessao, relator) {
        const url = `${
            this.configuracao.urlPregoes + this.localizacao
        }/sessoes/${idSessao}/relator/${relator.sigla}-${relator.cpf}/planilha`;
        return this.fetch(url, 'DELETE');
    }

    async cancelarPregao(numeroProcesso, idSessao) {
        const url = `${this.configuracao.urlPregoes + this.localizacao}/sessoes/${idSessao}/processos/${numeroProcesso}`;
        return this.fetch(url, 'DELETE');
    }

    async recuperarProcessoApregoado(localizacao) {
        const url = this.configuracao.urlPregoes + (localizacao || this.localizacao);
        const result = await this.fetchConfig({
            url: url,
            method: 'GET',
            data: {},
            addHeader: [{ parametro: 'Accept', valor: 'application/json' }],
            tratamentoErroComponente: true
        });
        return result.data;
    }

    async recuperarProcessoApregoadoAS(localizacao) {
        const url = this.configuracao.urlPregoesAS + (localizacao || this.localizacao);
        const result = await this.fetchConfig({
            url: url,
            method: 'GET',
            data: {},
            addHeader: [{ parametro: 'Accept', valor: 'application/json' }],
            tratamentoErroComponente: true
        });
        return result.data;
    }

    async notificar(idSessao) {
        // Fetch sem token
        axios({
            url: `${this.configuracao.urlNotificar + idSessao}/pregao?siglaoj=${this.localizacao}`,
            method: 'POST'
        });
    }

    async notificarPregao(idSessao, apregoado, marcarAusenciasAdvogados, totalDeProcessos) {
        // Fetch sem token
        axios({
            url: `${
                this.configuracao.urlNotificar + idSessao
            }/pregao?siglaoj=${this.localizacao}&apregoado=${apregoado}&marcarAusenciasAdvogados=${marcarAusenciasAdvogados}${totalDeProcessos ? '&totalDeProcessos=' + totalDeProcessos : ''}`,
            method: 'POST'
        });
    }

    async testarAlteracaoMinuta(idSessao, numeroProcesso) {
        axios({
            url: `${
                this.configuracao.urlNotificar + idSessao
            }/revogacao-voto?processo=${numeroProcesso}&usuario=sistema`,
            method: 'POST'
        });
    }

    async notificarJulgamento(idSessao, numeroProcesso, clienteEnvelopeId) {
        // Fetch sem token
        // se clienteEnvelopeId informado, permite tratar mensagem enviada pelo próprio cliente
        const paramClienteEnvelopeId = clienteEnvelopeId ? '&clienteEnvelopeId=' + clienteEnvelopeId : '';
        axios({
            url: `${
                this.configuracao.urlNotificar + idSessao
            }/processo?processo=${numeroProcesso}${paramClienteEnvelopeId}`,
            method: 'POST'
        });
    }

    async notificarAlterarProcesso(idSessao, numeroProcesso, clienteEnvelopeId, propriedade, valor) {
        // Fetch sem token
        // se clienteEnvelopeId informado, permite tratar mensagem enviada pelo próprio cliente
        const paramClienteEnvelopeId = clienteEnvelopeId ? '&clienteEnvelopeId=' + clienteEnvelopeId : '';
        const retornaValor = valor ? valor : '';
        const paramPropriedade = propriedade
            ? '&propriedade=' + propriedade + '&valor=' + encodeURIComponent(retornaValor)
            : '';
        axios({
            url: `${
                this.configuracao.urlNotificar + idSessao
            }/processo?processo=${numeroProcesso}${paramClienteEnvelopeId}${paramPropriedade}`,
            method: 'POST'
        });
    }

    async notificarJulgamentoLote(idSessao, clienteEnvelopeId) {
        // Fetch sem token
        const paramClienteEnvelopeId = clienteEnvelopeId ? '&clienteEnvelopeId=' + clienteEnvelopeId : '';
        axios({
            url: `${this.configuracao.urlNotificar + idSessao}?usuario=${this.cpfUsuario}${paramClienteEnvelopeId}`,
            method: 'POST'
        });
    }

    async notificarCronometro(idSessao, operacao, segTotal) {
        // Fetch sem token
        axios({
            url: `${this.configuracao.urlNotificar + idSessao}/cronometro?operacao=${operacao}&tempo=${segTotal}`,
            method: 'POST'
        });
    }

    async recuperarProcessoSessao(idSessao, numeroProcesso, ignorarCacheServidor) {
        const recarregarCache = ignorarCacheServidor ? '&recarregarCache=true' : '';
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}?nivelDetalhes=SalaSessao${recarregarCache}`;
        const result = await this.fetch(url);
        return result.data;
    }

    async recuperarSessaoComProcesso(idSessao, numeroProcesso) {
        const url = `${this.configuracao.urlSessoes + idSessao}?processo=${numeroProcesso}&nivelDetalhes=SalaSessao`;
        const result = await this.fetch(url);
        return result.data;
    }

    async recuperarComposicaoProcessoSessao(idSessao, numeroProcesso) {
        const result = await this.fetch(
            `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/composicao-pre-sessao`
        );
        return result.data;
    }

    async verificarLocalizacaoMagistrado(idSessao, sigla, cpf, converterSigla) {
        const url = `${this.configuracao.urlSessoes}${idSessao}/localizacaomagistrado?sigla=${sigla}&cpf=${cpf}&converterSigla=${converterSigla}`;
        const result = await this.fetch(url);
        return result.data;
    }

    async recuperarSessoesJulgamento(siglaOrgaoJulgador) {
        const url = `${this.configuracao.urlOrgaosJudicantes + siglaOrgaoJulgador}/sessoes`;
        const result = await this.fetch(url);
        return result.data;
    }

    async recuperarSessoesJulgamentoAS(siglaOrgaoJulgador) {
        const url = `${this.configuracao.urlOrgaosJudicantesAS + siglaOrgaoJulgador}/sessoes`;
        const result = await this.fetch(url);
        return result.data;
    }

    async recuperarComposicaoPadraoOJC(siglaOrgaoJulgador) {
        const url = `${this.configuracao.urlOrgaosJudicantes + siglaOrgaoJulgador}/composicao-padrao`;
        const result = await this.fetch(url);
        return result.data;
    }

    async gravarComposicaoPadraoSessao(idSessao, composicao) {
        return this.fetch(`${this.configuracao.urlSessoes + idSessao}/composicao-padrao`, 'PUT', composicao);
    }

    async recuperarSessaoJulgamento(idSessao, notificarOrdenacao, ignorarCacheServidor) {
        const notificarClientes = notificarOrdenacao ? '&notificarOrdenacao=true' : '';
        const recarregarCache = ignorarCacheServidor ? '&recarregarCache=true' : '';
        const url = `${this.configuracao.urlSessoes + idSessao}?nivelDetalhes=SalaSessao&ordenacao=SalaSessao${notificarClientes}${recarregarCache}`;
        const result = await this.fetch(url);
        return result.data;
    }

    async registrarVistaMesa(idSessao, numeroProcesso, magistrados) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/vista-mesa',
            'PUT',
            magistrados
        );
        return result.data;
    }

    async excluirVistaMesa(idSessao, numeroProcesso, magistrados) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/vista-mesa',
            'DELETE',
            magistrados || []
        );
        return result.data;
    }

    async alterarRetornoVistaRegimental(idSessao, numeroProcesso, magistrados) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/vista-regimental/alterar?retornoVista=true`;

        const result = await this.fetch(url, 'PUT', magistrados);
        return result.data;
    }

    async registrarRetornoVistaRegimental(idSessao, numeroProcesso, magistrados) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/vista-regimental?retornoVista=true`;

        const result = await this.fetch(url, 'PUT', magistrados);
        return result.data;
    }

    async excluirRetornoVistaRegimental(idSessao, numeroProcesso, magistrados) {
        const result = await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/vista-regimental?retornoVista=true',
            'DELETE',
            magistrados || []
        );
        return result.data;
    }

    async excluirProcurador(idSessao) {
        const result = await this.fetch(this.configuracao.urlSessoes + idSessao + '/procurador', 'DELETE');
        return result.data;
    }

    async salvarOrdenacaoSecretario(idSessao, numeroProcesso, ordenacaoSecretario) {
        await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/ordenacao-secretario',
            'POST',
            ordenacaoSecretario,
            [
                {
                    parametro: 'Content-type',
                    valor: 'text/plain'
                }
            ]
        );
    }

    async excluirOrdenacaoSecretario(idSessao, numeroProcesso) {
        await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/ordenacao-secretario',
            'DELETE'
        );
    }

    async salvarSequenciaPreferenciaRegimental(idSessao, numeroProcesso, sequenciaPreferencia) {
        await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/sequencia-preferencia-regimental',
            'POST',
            sequenciaPreferencia,
            [
                {
                    parametro: 'Content-type',
                    valor: 'text/plain'
                }
            ]
        );
    }

    async saveSequenciaPreferenciaArbitraria(idSessao, numeroProcesso, sequenciaPreferencia) {
        await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/sequencia-preferencia-arbitraria',
            'POST',
            sequenciaPreferencia,
            [
                {
                    parametro: 'Content-type',
                    valor: 'text/plain'
                }
            ]
        );
    }

    salvarOuDeletarSequenciaPreferenciaRegimental(idSessao, numeroProcesso, sequenciaPreferencia) {
        const promise =
            sequenciaPreferencia && sequenciaPreferencia.length > 0
                ? this.salvarSequenciaPreferenciaRegimental(idSessao, numeroProcesso, sequenciaPreferencia)
                : this.excluirSequenciaPreferenciaRegimental(idSessao, numeroProcesso);
        return promise;
    }

    salvarSequenciaPreferenciaArbitraria(idSessao, numeroProcesso, sequenciaPreferencia) {
        const promise =
            sequenciaPreferencia && sequenciaPreferencia.length > 0
                ? this.saveSequenciaPreferenciaArbitraria(idSessao, numeroProcesso, sequenciaPreferencia)
                : this.deleteSequenciaPreferenciaArbitraria(idSessao, numeroProcesso);
        return promise;
    }

    async excluirSequenciaPreferenciaRegimental(idSessao, numeroProcesso) {
        const url = `${this.configuracao.urlSessoes}${idSessao}/processos/${numeroProcesso}/sequencia-preferencia-regimental`;
        await this.fetch(url, 'DELETE');
    }

    async deleteSequenciaPreferenciaArbitraria(idSessao, numeroProcesso) {
        const url = `${this.configuracao.urlSessoes}${idSessao}/processos/${numeroProcesso}/sequencia-preferencia-arbitraria`;
        await this.fetch(url, 'DELETE');
    }

    async salvarSequenciaPreferenciaInscricao(idSessao, numeroProcesso, oab, sequenciaPreferencia) {
        const paramLetra = oab.letra ? `-${oab.letra}` : '';
        const url = `${this.configuracao.urlSessoes}${idSessao}/processos/${numeroProcesso}/representantes/${oab.numero}-${oab.siglaUf}${paramLetra}/sequencial`;

        await this.fetch(url, 'PUT', sequenciaPreferencia, [
            {
                parametro: 'Content-type',
                valor: 'text/plain'
            }
        ]);
    }

    async excluirSequenciaPreferenciaInscricao(idSessao, numeroProcesso, oab) {
        const paramLetra = oab.letra ? `-${oab.letra}` : '';
        const url = `${this.configuracao.urlSessoes}${idSessao}/processos/${numeroProcesso}/representantes/${oab.numero}-${oab.siglaUf}${paramLetra}/sequencial`;
        await this.fetch(url, 'DELETE');
    }

    async recuperarDestaques(idSessao, numeroProcesso, siglaMagistrado) {
        const result = await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/observacoes/4/' +
                siglaMagistrado
        );
        return result.data;
    }

    async recuperarConteudoDestaque(idSessao, numeroProcesso, siglaMagistrado, idDestaque) {
        const result = await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/observacoes/4/' +
                siglaMagistrado +
                '/' +
                idDestaque
        );
        return result.data;
    }

    async recuperarConteudoRtfDestaque(idSessao, numeroProcesso, siglaMagistrado, idDestaque) {
        const result = await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/observacoes/4/' +
                siglaMagistrado +
                '/' +
                idDestaque +
                '/conteudo'
        );
        return result.data;
    }

    async recuperarVotosVista(idSessao, numeroProcesso, siglaMagistrado) {
        const result = await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/observacoes/4/' +
                siglaMagistrado
        );
        return result.data;
    }

    async alterarProcurador(idSessao, numeroProcesso, procurador) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/procurador',
            'POST',
            procurador
        );
        return result.data;
    }

    async alterarSituacaoSessao(idSessao, situacao) {
        const result = await this.fetch(this.configuracao.urlSessoes + idSessao + '/situacao', 'PUT', situacao, [
            {
                parametro: 'Content-type',
                valor: 'text/plain'
            }
        ]);
        return result.data;
    }

    async recuperarProcurador(idSessao) {
        const result = await this.fetch(this.configuracao.urlSessoes + idSessao + '/procurador');
        return result.data;
    }

    async gravarProcurador(idSessao, procurador) {
        await this.fetch(this.configuracao.urlSessoes + idSessao + '/procurador', 'POST', procurador);
    }

    async gravarPresidente(idSessao, presidente) {
        await this.fetch(this.configuracao.urlSessoes + idSessao + '/presidente', 'PUT', presidente.sigla, [
            {
                parametro: 'Content-type',
                valor: 'text/plain'
            }
        ]);
    }

    async ordenarProcessos(idSessao) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/ordenacao',
            'POST',
            undefined,
            undefined,
            undefined,
            true
        );
        return result.data;
    }

    async incluirProcesso(idSessao, numeroProcesso, preparacaoPauta, tipoJulgamento) {
        let url =
            this.configuracao.urlSessoes +
            idSessao +
            '/processos/' +
            numeroProcesso +
            '?preparacaoPauta=' +
            preparacaoPauta;

        if (tipoJulgamento) {
            url += '&tipoJulgamento=' + tipoJulgamento;
        }

        const result = await this.fetch(url, 'PUT');
        return result.data;
    }

    async listarPendencias(idSessao) {
        const result = await this.fetch(this.configuracao.urlSessoes + idSessao + '/pendencias-fechamento');
        return result.data;
    }

    async recuperarTiposPendenciasFechamento() {
        const result = await this.fetch(this.configuracao.urlSessoes + 'tipos-pendencias-fechamento');
        return result.data;
    }

    async listarSessoesPendentes(idsSessoes) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + 'possui-pendencias-fechamento',
            'POST',
            idsSessoes,
            [
                {
                    parametro: 'Content-type',
                    valor: 'text/plain'
                }
            ]
        );
        return result.data;
    }

    async liberarVotosSessao(idSessao) {
        console.debug('Liberando votos da sessão ' + idSessao) + '...';
        const result = await this.fetch(this.configuracao.urlSessoes + idSessao + '/liberar-votos-sessao');
        return result.data;
    }

    async liberarDispositivosVoto(idSessao, numerosProcessos) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/liberacao-dispositivo-voto',
            'PUT',
            numerosProcessos
        );
        return result.data;
    }

    async recuperarPautaJulgamento(sessaoId) {
        const result = await this.fetch(this.configuracao.urlPautas + '/' + sessaoId);
        return result.data;
    }

    async excluirPautasJulgamento(sessaoId) {
        const url = `${this.configuracao.urlPautas}/${sessaoId}`;
        const result = await this.fetch(url, 'DELETE');
        return result.data;
    }

    async recuperarPautaveis(sessaoId) {
        const result = await this.fetch(this.configuracao.urlPautas + '/' + sessaoId + '/processos-pautaveis');
        return result.data;
    }

    async recuperarPartesSessao(sessaoId) {
        const result = await this.fetchConfig({
            url: this.configuracao.urlSessoes + sessaoId + '/partes',
            background: true
        });
        return result.data;
    }

    async recuperarMovimentosDecisoesSessao(sessaoId) {
        const result = await this.fetchConfig({
            url: this.configuracao.urlSessoes + sessaoId + '/movimentos-decisoes',
            background: true
        });
        return result.data;
    }

    async recuperarPartesPautaveis(sessaoId) {
        const result = await this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + sessaoId + '/processos-pautaveis/partes',
            background: true
        });
        return result.data;
    }

    async recuperarJulgamentoAnteriorPautaveis(sessaoId) {
        const result = await this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + sessaoId + '/processos-pautaveis/julgamento-anterior',
            background: true
        });
        return result.data;
    }

    async recuperarUltimosAndamentosSessao(sessaoId) {
        const result = await this.fetchConfig({
            url: this.configuracao.urlSessoes + sessaoId + '/ultimos-andamentos',
            background: true
        });
        return result.data;
    }

    async recuperarUltimosAndamentosPautaveis(sessaoId) {
        const result = await this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + sessaoId + '/processos-pautaveis/ultimos-andamentos',
            background: true
        });
        return result.data;
    }

    async recuperarJulgamentosAnterioresSessao(sessaoId) {
        const result = await this.fetchConfig({
            url: this.configuracao.urlSessoes + sessaoId + '/julgamento-anterior',
            background: true
        });
        return result.data;
    }

    async recuperarDatasVotacaoVirtual(dataInicioSessaoPresencial, regrasResolucaoCnj591) {
        let url = `${this.configuracao.urlPautas}/sugestao-prazos?dataInicioSessaoPresencial=${dataInicioSessaoPresencial}`;

        if (regrasResolucaoCnj591) {
            url += `&regrasResolucaoCnj591=${regrasResolucaoCnj591}`;
        }

        const result = await this.fetch(url);
        return result.data;
    }

    async recuperarDatasVotacao(dataInicioVotacaoVirtual, dataFimVotacaoVirtual, regrasResolucaoCnj591) {
        let url = `${this.configuracao.urlPautas}/sugestao-prazos-virtual?`;

        if (dataFimVotacaoVirtual) {
            url += `dataFimVotacaoVirtual=${dataFimVotacaoVirtual}`;
        } else if (dataInicioVotacaoVirtual) {
            url += `dataInicioVotacaoVirtual=${dataInicioVotacaoVirtual}`;
        }

        if (regrasResolucaoCnj591) {
            url += `&regrasResolucaoCnj591=${regrasResolucaoCnj591}`;
        }

        const result = await this.fetch(url);
        return result.data;
    }

    async gravarPautaJulgamento(pautaJulgamento) {
        const result = await this.fetch(this.configuracao.urlPautas, 'POST', pautaJulgamento);
        return result.data;
    }

    async gerarAta(idSessao, tipoJulgamento) {
        const paramTipoJulgamento =
            Array.isArray(tipoJulgamento) && tipoJulgamento.length > 0
                ? `?tipoJulgamento=${tipoJulgamento.join('&tipoJulgamento=')}`
                : '';
        const result = await this.fetch(
            `${this.configuracao.urlSessoes + idSessao}/ata${paramTipoJulgamento}`,
            'GET',
            null,
            undefined,
            'blob'
        );
        return result.data;
    }

    async buscarOrgaosJulgadoresColegiados() {
        const result = await this.fetch(this.configuracao.urlOrgaosJudicantes);
        return result.data;
    }

    async buscarOrgaosJulgadoresColegiadosAS() {
        const result = await this.fetch(this.configuracao.urlOrgaosJudicantesAS);
        return result.data;
    }

    async buscarMotivosImpedimentos(idSessao, numeroProcesso) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/impedimentos'
        );
        return result.data;
    }

    async registrarAnaliseMinuta(idSessao, numeroProcesso) {
        console.debug(`Registrando que a minuta de voto foi analisada pela secretaria... [${numeroProcesso}]`);
        const url = `${this.configuracao.urlBaseSessao}/analises-minutas/sessoes/${idSessao}/processos/${numeroProcesso}`;
        const result = await this.fetch(url, 'PUT');
        return result.data;
    }

    async consultarVersoesMinutaVoto(idSessao, numeroProcesso, isRelator) {
        console.debug(`Consultando versões da minuta de voto... [${numeroProcesso}]`);
        const url = `${this.configuracao.urlBaseSessao}/sessoes/${idSessao}/processos/${numeroProcesso}/versoes-minuta?relator=${isRelator}`;
        const result = await this.fetch(url, 'GET');
        return result.data;
    }

    async consultarVersaoMinutaVoto(idSessao, numeroProcesso, idGed, extensaoVersaoGed, naoRelator) {
        console.debug(`Consultando conteúdo da versão de minuta de voto... [${numeroProcesso}|gedId:${idGed}]`);
        const url = `${this.configuracao.urlBaseSessao}/sessoes/${idSessao}/processos/${numeroProcesso}/versao-minuta?gedId=${idGed}&versao=${extensaoVersaoGed}&naoRelator=${naoRelator}`;
        const result = await this.fetch(url, 'GET');
        return result.data;
    }

    async gerarPreVisualizacaoCertidao(idSessao, numeroProcesso, datasPreVisualizacaoCertidao) {
        const result = await this.fetchConfig({
            url:
                this.configuracao.urlPautas + '/' + idSessao + '/' + numeroProcesso + '/previa-certidao-inclusao-pauta',
            method: 'PUT',
            data: datasPreVisualizacaoCertidao,
            responseType: 'text'
        });
        return result.data;
    }

    async recuperarPrazosPublicacaoPauta(dataInicioJulgamento, dataDisponibilizacao) {
        const dataDisponibilizacaoParam = dataDisponibilizacao ? '&dataDisponibilizacao=' + dataDisponibilizacao : '';
        const result = await this.fetch(
            this.configuracao.urlPautas +
                '/prazos-publicacao?dataInicioJulgamento=' +
                dataInicioJulgamento +
                dataDisponibilizacaoParam
        );
        return result.data;
    }

    async validarMotivosProcessoInapto(idSessao, numeroProcesso) {
        const result = await this.fetch(
            this.configuracao.urlPautas + '/' + idSessao + '/motivos-inapto/' + numeroProcesso
        );
        return result.data;
    }

    async importarSalaSessao(idSessao, numeroProcesso) {
        return this.fetchConfig({
            url: this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/importar-sala-sessao',
            method: 'PUT',
            tratamentoErroComponente: true
        });
    }

    async buscarDecisaoCertidaoAssinados(sessaoId) {
        const response = await this.fetchConfig({
            url: `${this.configuracao.urlSessoes}${sessaoId}/decisao-voto-certidao`,
            method: 'GET'
        });
        return response.data;
    }

    async buscarDadosAnaliseSecretaria(sessaoId) {
        const response = await this.fetchConfig({
            url: `${this.configuracao.urlSessoes}${sessaoId}/segmentos-voto-certidao?formatoConteudo=TEXTO`,
            method: 'GET'
        });
        return response.data;
    }

    async reiniciarAnaliseDecisao(idSessao, numeroProcesso) {
        return this.fetchConfig({
            url:
                this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/reiniciar-analise-decisao',
            method: 'PUT',
            tratamentoErroComponente: true
        });
    }

    async confirmarPublicarPauta(idSessao, publicarPautaDto) {
        return this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + idSessao + '/confirmar-inclusao',
            method: 'PUT',
            data: publicarPautaDto,
            tratamentoErroComponente: true
        });
    }

    async cancelarDisponibilizacaoDiario(idSessao, numeroProcesso, motivoCancelamento) {
        return this.fetchConfig({
            url:
                this.configuracao.urlPautas +
                '/' +
                idSessao +
                '/' +
                numeroProcesso +
                '/publicacao-diario?motivoCancelamento=' +
                motivoCancelamento,
            method: 'DELETE',
            tratamentoErroComponente: true
        });
    }

    async cancelarDisponibilizacoesDiario(idSessao, numerosProcessos, motivoCancelamento) {
        return this.fetchConfig({
            url:
                this.configuracao.urlPautas +
                '/' +
                idSessao +
                '/cancelar-publicacao-diario?motivoCancelamento=' +
                motivoCancelamento,
            method: 'PUT',
            data: numerosProcessos,
            tratamentoErroComponente: true
        });
    }

    async gerarCertidaoInclusaoPauta(idSessao, publicarPautaDto) {
        return this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + idSessao + '/gerar-certidao-inclusao-pauta',
            method: 'PUT',
            data: publicarPautaDto,
            tratamentoErroComponente: true
        });
    }

    async publicarPautaDiario(idSessao, publicarPautaDto) {
        return this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + idSessao + '/publicar-diario',
            method: 'PUT',
            data: publicarPautaDto,
            tratamentoErroComponente: true
        });
    }

    async tramitarInclusaoPauta(idSessao, publicarPautaDto) {
        const resultado = await this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + idSessao + '/tramitar-inclusao-pauta',
            method: 'PUT',
            data: publicarPautaDto,
            tratamentoErroComponente: true
        });
        return resultado;
    }

    async fecharPauta(idSessao, tiposInclusao) {
        const tiposInclusaoParam = tiposInclusao.map((tipo) => 'tipoInclusao=' + tipo).join('&');
        const result = await this.fetch(
            this.configuracao.urlPautas + '/' + idSessao + '/fechar?' + tiposInclusaoParam,
            'PUT'
        );
        return result.data;
    }

    async fecharLivroPreferencias(idSessao) {
        await this.fetch(this.configuracao.urlSessoes + idSessao + '/fechar-livro-preferencias', 'PUT');
    }

    async buscarCabecalhoPulicacaoPauta(idSessao) {
        const result = await this.fetch(this.configuracao.urlPautas + '/' + idSessao + '/cabecalho-publicacao');
        return result.data;
    }

    async buscarCabecalhoEditalCancelamento(idSessao) {
        const result = await this.fetch(
            this.configuracao.urlPautas + '/' + idSessao + '/cabecalho-edital-cancelamento'
        );
        return result.data;
    }

    async existePauta(idSessao) {
        const url = `${this.configuracao.urlPautas}/${idSessao}/existe`;

        const result = await this.fetch(url, 'GET', null, [{ parametro: 'Content-type', valor: 'text/plain' }]);

        return result.data;
    }

    async recuperarAutoTexto(siglaOrgaoJudicante) {
        const url = `${this.configuracao.urlOrgaosJudicantes}${siglaOrgaoJudicante}/auto-texto`;
        const result = await this.fetch(url);
        return result.data;
    }

    async cadastrarAutoTexto(data) {
        const url = `${this.configuracao.urlOrgaosJudicantes}${data.siglaOrgaoJudicante}/auto-texto`;
        const result = await this.fetch(url, 'POST', data);
        return result.data;
    }

    async editarAutoTexto(data) {
        const url = `${this.configuracao.urlOrgaosJudicantes}${data.siglaOrgaoJudicante}/auto-texto/${data.id}`;
        const result = await this.fetch(url, 'PUT', data);
        return result.data;
    }

    async removerAutoTexto(data) {
        const url = `${this.configuracao.urlOrgaosJudicantes}${data.siglaOrgaoJudicante}/auto-texto/${data.id}`;
        const result = await this.fetch(url, 'DELETE');
        return result.data;
    }

    async recuperarInformacoesRelatorioProcessos(idSessao, listaProcessos) {
        const url = `${this.configuracao.urlSessoes}${idSessao}/partes-ementa-decisao`;
        const result = await this.fetch(url, 'POST', listaProcessos);
        return result.data;
    }

    async forcarAtualizacaoEmentaDecisao(idSessao, numeroProcesso) {
        console.debug(
            `Forçando atualização de ementa e decisão do GE... [idSessao: ${idSessao}; processo: ${numeroProcesso}]`
        );
        const url = this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/forcar-atualizar-planilha';
        const result = await this.fetch(url, 'POST');
        return result.data;
    }

    async recuperarInformacoesPendenciasConferencia(idSessao, listaProcessos) {
        const url = `${this.configuracao.urlSessoes}${idSessao}/validacoes-pre-sessao`;
        const result = await this.fetch(url, 'POST', listaProcessos);
        return result.data;
    }

    async downloadDocumento(arquivoId) {
        const result = await this.fetchConfig({
            url: `${this.configuracao.urlSessaoInscricaoAdvogado}documentos/${arquivoId}`,
            responseType: 'blob'
        });
        return result.data;
    }

    async aprovarSustentacaoOral(arquivoId) {
        const result = await this.fetchConfig({
            url: `${this.configuracao.urlSessaoInscricaoAdvogado}documentos/${arquivoId}/aprovar`,
            method: 'PUT'
        });
        return result.data;
    }

    async reprovarSustentacaoOral(arquivoId, motivoReprovacao) {
        const result = await this.fetch(
            `${this.configuracao.urlSessaoInscricaoAdvogado}documentos/${arquivoId}/reprovar`,
            'PUT',
            motivoReprovacao,
            [{ parametro: 'Content-type', valor: 'text/plain' }]
        );
        return result.data;
    }

    async limparMarcacaoSustentacaoOral(arquivoId) {
        const result = await this.fetchConfig({
            url: `${this.configuracao.urlSessaoInscricaoAdvogado}documentos/${arquivoId}/validacao`,
            method: 'DELETE'
        });
        return result.data;
    }

    async consultarTranscricaoSustentacaoOralEletronica(arquivoId) {
        console.debug(`Consultando transcrição "${arquivoId}"...`);
        const url = `${this.configuracao.urlBaseSessao}/documento-transcricao/${arquivoId}`;
        const result = await this.fetch(url, 'GET');
        return result.data;
    }

    async salvarTranscricaoSustentacaoOralEletronica(arquivoId, textoTranscricao, textoObservacao) {
        console.debug(`Gravando transcrição "${arquivoId}"...`);
        const url = `${this.configuracao.urlBaseSessao}/documento-transcricao/${arquivoId}`;
        const updatedData = {
            observacao: textoObservacao,
            transcricao: textoTranscricao
        };
        await this.fetch(url, 'PUT', updatedData);
    }

    async excluirTranscricaoSustentacaoOralEletronica(arquivoId) {
        console.debug(`Excluindo transcrição "${arquivoId}"...`);
        const url = `${this.configuracao.urlBaseSessao}/documento-transcricao/${arquivoId}`;
        const result = await this.fetch(url, 'DELETE');
        return result.data;
    }

    async consultarPautasDoProcesso(numeroProcesso) {
        const url = `${this.configuracao.urlBaseSessao}/processos/${numeroProcesso}/sessoes`;
        const result = await this.fetch(url, 'GET');
        return result.data;
    }

    async downloadCertidaoNaoAtendimentoExigencias(sessaoId, numeroProcesso, arquivoId) {
        const result = await this.fetchConfig({
            url: `${this.configuracao.urlBaseSessao}/documentos/${sessaoId}/${numeroProcesso}/${arquivoId}/PDF/conteudo`,
            responseType: 'blob'
        });
        return result;
    }

    async gerarCertidaoNaoAtendimentoExigenciasPorProcesso(sessaoId, numeroProcesso, chaveOtp) {
        const result = await this.fetchConfig({
            url:
                `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/gerar-certidao-nao-atendimento-sustentacao?chaveOtp=` +
                chaveOtp,
            method: 'POST'
        });
        return result.data;
    }

    async gerarCertidaoNaoAtendimentoExigencias(sessaoId, numeroProcesso, documentoId, chaveOtp) {
        const result = await this.fetchConfig({
            url:
                `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/document/${documentoId}/certidao-nao-atendimento-sustentacao?chaveOtp=` +
                chaveOtp,
            method: 'POST'
        });
        return result.data;
    }

    async recuperarMovimentacoesInternas(sessaoId) {
        const url = `${this.configuracao.urlSessoes}${sessaoId}/movimentacao-interna`;
        const result = await this.fetch(url);
        return result.data;
    }

    async consultarMaterias(sessaoId, numeroProcesso) {
        const url = `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/materia`;
        const result = await this.fetch(url, 'GET');
        return result.data;
    }

    async cadastrarMateria(sessaoId, numeroProcesso, materiaDto) {
        return this.fetchConfig({
            url: `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/materia`,
            method: 'POST',
            data: materiaDto
        });
    }

    async alterarDescricaoMateria(materiaId, descricao) {
        const url = `${this.configuracao.urlBaseSessao}/materia/${materiaId}/descricao`;
        const updatedData = {
            descricao
        };
        await this.fetch(url, 'PATCH', updatedData, [{ parametro: 'Content-Type', valor: 'application/json' }]);
    }

    async excluirMateria(materiaId) {
        return this.fetchConfig({
            url: `${this.configuracao.urlBaseSessao}/materia/${materiaId}`,
            method: 'DELETE'
        });
    }

    async cadastrarDeliberacao(materiaId, deliberacaoDto) {
        return this.fetchConfig({
            url: `${this.configuracao.urlBaseSessao}/materia/${materiaId}/deliberacao`,
            method: 'POST',
            data: deliberacaoDto
        });
    }

    async alterarDeliberacao(deliberacaoId, deliberacaoDto) {
        return this.fetchConfig({
            url: `${this.configuracao.urlBaseSessao}/deliberacao/${deliberacaoId}`,
            method: 'PUT',
            data: deliberacaoDto
        });
    }

    async alterarDescricaoDeliberacao(deliberacaoId, descricao) {
        return this.fetch(`${this.configuracao.urlBaseSessao}/deliberacao/${deliberacaoId}/descricao`, 'PATCH', {
            descricao
        });
    }

    async alterarMagistradoResponsavelDeliberacao(deliberacaoId, magistradoResponsavel) {
        return this.fetch(
            `${this.configuracao.urlBaseSessao}/deliberacao/${deliberacaoId}/magistrado-responsavel`,
            'PATCH',
            {
                magistradoResponsavel
            }
        );
    }

    async excluirDeliberacao(deliberacaoId) {
        return this.fetchConfig({
            url: `${this.configuracao.urlBaseSessao}/deliberacao/${deliberacaoId}`,
            method: 'DELETE'
        });
    }

    async incluirVotoDeliberacao(deliberacaoId, magistradoResponsavel, tipoVoto) {
        return this.fetchConfig({
            url: `${this.configuracao.urlBaseSessao}/deliberacao/${deliberacaoId}/voto-deliberacao`,
            method: 'PUT',
            data: {
                magistradoResponsavel,
                tipo: { id: tipoVoto }
            }
        });
    }

    async salvarObservacoes(sessaoId, numeroProcesso, observacaoDto) {
        return this.fetchConfig({
            url: `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/voto-observacao`,
            method: 'POST',
            data: observacaoDto
        });
    }

    async intimarPauta(idSessao, intimarPautaDto) {
        const resultado = await this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + idSessao + '/intimar',
            method: 'PUT',
            data: intimarPautaDto,
            tratamentoErroComponente: true
        });
        return resultado;
    }

    async gerarCertidaoIntimacao(idSessao, publicarPautaDto) {
        const resultado = await this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + idSessao + '/gerar-certidao-intimacao',
            method: 'PUT',
            data: publicarPautaDto,
            tratamentoErroComponente: true
        });
        return resultado;
    }

    async tramitarIntimacao(idSessao, publicarPautaDto) {
        const resultado = await this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + idSessao + '/tramitar-intimacao',
            method: 'PUT',
            data: publicarPautaDto,
            tratamentoErroComponente: true
        });
        return resultado;
    }
}

export default SessaoApi;
